<template>
	<el-container>
		<Menu :activeIndex='activeIndex'></Menu>
		<el-container>
			<el-header>
				<h2>打卡管理</h2>
			</el-header>
			<el-container style="border:10px solid #E9EEF3;">
				<el-aside width="350px" style='border-right:10px solid #e9eef3;'>
					<div class='editConpon clearfix'>
						<div class="box_item">
							<el-input size="small" placeholder="请输入学员昵称查找" v-model="searchname" class="input-with-select">
								<el-button size='mini' slot="append" icon="el-icon-search" v-on:click="seachstudent"></el-button>
							</el-input>
						</div>
					</div>
					<div class='viptable'>
						<el-table ref="multipleTable" :data="vipData" :stripe="true" tooltip-effect="dark" style="width: 100%" highlight-current-row @current-change="handleRowChange">
							<el-table-column label="头像" width="70">
								<div slot-scope="scope" style="padding:5px 0;">
									<img :src="scope.row.headimgurl" alt="" style="width:50px;display:block;">
								</div>
							</el-table-column>
							<el-table-column prop="nickname" label="昵称" width="120" :show-overflow-tooltip="true">
							</el-table-column>
							<el-table-column prop="city" label="城市" show-overflow-tooltip>
							</el-table-column>
              <el-table-column prop="id" label="ID" show-overflow-tooltip>
              </el-table-column>
						</el-table>
						<el-pagination :pager-count="5" style="background:#fff;" :page-size="20" @current-change="handleCurrentChange" :current-page.sync="vipCurrentPage" layout="prev, pager, next" :total="dataTotal"></el-pagination>
					</div>
				</el-aside>
				<!--<el-aside width="292px">

				</el-aside>-->
				<el-main style="background:#fff;">
					<div>
						<div class='editConpon clearfix'>
							课程：
							<el-select v-model="currentCourseId" placeholder="请选择" @change='changeCourse'>
								<el-option v-for="(item,index) in courseList" :key="index" :label="item.name" :value="item.id"></el-option>
							</el-select>
							<div class="point_btn">
								<el-button type="success" v-on:click="getpointDt">查看积分详情</el-button>
							</div>
						</div>

						<el-table :data="classList" ref='singleTable' @current-change="classRowChange" highlight-current-row style="width: 100%;" :stripe="true" :border='true' :default-sort="{prop: 'date', order: 'descending'}">
							<el-table-column type="index" width="50"></el-table-column>
							<el-table-column prop="title" label="课时" :show-overflow-tooltip="true"></el-table-column>
							<el-table-column prop="plandate" label="计划日期" :show-overflow-tooltip="true"></el-table-column>
							<el-table-column label="打卡状态" :show-overflow-tooltip="true">
								<template slot-scope="scope">
									<span v-if="scope.row.isclock==0" style="color:#d00;">未打卡</span>
									<span v-if="scope.row.isclock==1" style="color:#0ab807;">正常打卡</span>
									<span v-if="scope.row.isclock==2" style="color:#e6762a;">补卡</span>
								</template>
							</el-table-column>
							<el-table-column label="操作" :show-overflow-tooltip="true">
								<template slot-scope="scope">
									<p style="color:#409eff;cursor:pointer;" v-on:click="editCard(scope.row.isclock,scope.row.id,scope.$index)"><i class="el-icon-edit"></i> 修改</p>
								</template>
							</el-table-column>
						</el-table>
						<el-pagination style="background:#fff;" :page-size="9" @current-change="handleClassChange" :current-page.sync="classPage" layout="prev, pager, next" :total="classdataTotal"></el-pagination>
					</div>

				</el-main>
			</el-container>
			<el-footer>Copyright &copy; Soren经济学人 技术支持 ：
				<a href="#">苏州西西弗斯商务信息咨询有限公司</a>
			</el-footer>
			<el-dialog title="修改打卡状态" :visible.sync="editCardState" width="30%">
				<div>
					<el-radio v-model="cardradio" label="0">未打卡</el-radio>
  					<el-radio v-model="cardradio" label="1">正常打卡</el-radio>
  					<el-radio v-model="cardradio" label="2">补卡</el-radio>
				</div>
				<span slot="footer" class="dialog-footer">
			    	<el-button @click="editCardState = false">取 消</el-button>
			    	<el-button type="primary" @click="editCardState = false,changeCard()">确 定</el-button>
			  </span>
			</el-dialog>
			<el-dialog title="积分详情" class="pointtable" :visible.sync="editPointState">
				<div>
					<div class="addPoint clearfix">
						<p>当前积分总数：<span style="color:#d00;font-size:22px;" v-text="allpointsnum"></span></p>
						<el-button class="_btn" type="success" v-on:click="addPointEvent">添加积分</el-button>
					</div>
					<el-table :data="pointData" ref='singleTable' @current-change="classRowChange" highlight-current-row style="width: 100%;" :stripe="true" :border='true' :default-sort="{prop: 'date', order: 'descending'}">
						<el-table-column type="index" width="50"></el-table-column>
						<el-table-column prop="points" label="积分" :show-overflow-tooltip="true"></el-table-column>
						<el-table-column prop="createtime" label="获取日期" :show-overflow-tooltip="true"></el-table-column>
						<el-table-column label="使用状态" :show-overflow-tooltip="true" width="100">
							<template slot-scope="scope">
								<span v-if="scope.row.usestate==0" style="color:#d00;">已使用</span>
								<span v-if="scope.row.usestate==1" style="color:#0ab807;">可用</span>
							</template>
						</el-table-column>
						<el-table-column label="操作" :show-overflow-tooltip="true" width="200">
							<template slot-scope="scope">
								<!--<span style="color:#409eff;cursor:pointer;margin-right:30px;" v-on:click="editCard(scope.row.isclock,scope.row.id,scope.$index)"><i class="el-icon-edit"></i> 修改</span>-->
								<span style="color:#d00;cursor:pointer;" v-on:click="delpoint(scope.$index,scope.row.id)"><i class="el-icon-edit"></i> 删除</span>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<span slot="footer" class="dialog-footer">
			    	<el-button @click="editPointState = false">取 消</el-button>
			    	<el-button type="primary" @click="editPointState = false,changePoint()">确 定</el-button>
			  </span>
			</el-dialog>
			<el-dialog title="添加积分" :visible.sync="addPointState">
				<div class='box_item clearfix'>
					<span class="_lebel">积分：</span>
					<div class="_con">
						<el-input placeholder="请输入积分数量" size="medium" v-model="point_num" class="input-with-select"></el-input>
					</div>
				</div>
				<span slot="footer" class="dialog-footer">
			    	<el-button @click="addPointState = false">取 消</el-button>
			    	<el-button type="primary" @click="addPointState = false,sureAddPoint()">确 定</el-button>
			  </span>
			</el-dialog>
		</el-container>
		<div class="load_page" v-loading="loading" element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)" element-loading-customClass="load_icon" v-show="loading"></div>
	</el-container>

</template>

<script>
	export default {
		data() {
			return {
				activeIndex: "8",
				searchname: '',
				vipData: [],
				dataTotal: 0,
				vipCurrentPage: 1,
				currentRow: null,
				courseList: [],
				classList: [],
				classPage: 1,
				classdataTotal: 0,
				currentCourseId: '', //选中课程
				vipopenid: '',
				editCardState:false,
				cardradio:'',
				changeId:'',
				currentIndex:0,
				loading:false,
				editPointState:false,
				pointData:[],
				addPointState:false,
				point_num:7,
				allpointsnum:0
			};
		},
		mounted() {
			this.getVipPerSons(1, this.searchname);
		},
		updated: function() {

		},
		components: {

		},
		methods: {
			sureAddPoint:function(){
				var that = this;
				that.axios.post('/myPoints/add', {
					mark:'xueqiu',
  					openid:that.vipopenid,
  					courseid:that.currentCourseId,
  					points:that.point_num,
  					usestate:1
				})
				.then(function(response) {
					if(response.data.code == "600") {
						that.$message({
							type: 'success',
							message: '添加成功!'
						});
						var timer = setInterval(function() {
							that.getpointDt();
							clearInterval(timer);
						}, 100);
					} else if(response.data.code == "400") {
						that.$message({
							type: "error",
							message: "操作失败"
						});
					}
				})
				.catch(function(error) {
					//console.log(error);
				});
			},
			addPointEvent:function(){
				var that = this;

				if(that.currentCourseId){
					that.addPointState = true;
				}else{
					that.$message({
						type: "error",
						message: "未选中课程"
					});
				}
			},
			delpoint:function(index,id){//删除积分
				var that = this;
				that.$confirm('确定要删除该积分吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					that.axios.post('/myPoints/delete', {
						id: id
					})
					.then(function(response) {
						if(response.data.code == "600") {
							that.$message({
								type: 'success',
								message: '删除成功!'
							});
							var timer = setInterval(function() {
								that.getpointDt();
								clearInterval(timer);
							}, 100);
						} else if(response.data.code == "400") {
							that.$message({
								type: "error",
								message: "操作失败"
							});
						}
					})
					.catch(function(error) {
						//console.log(error);
					});
				})
			},
			getpointDt:function(){
				var that = this;
				if(!that.vipopenid){
					that.$message({
						type: "error",
						message: "请先选择学员"
					});
				}else if(!that.currentCourseId){
					that.$message({
						type: "error",
						message: "暂无相应课程"
					});
				}else{
					that.editPointState = true;
					that.axios.post('/myPoints/list', {
						mark:'xueqiu',
						openid:that.vipopenid,
	  					courseid:that.currentCourseId
					})
					.then(function(response) {
						if(response.data.code == "600") {
							that.allpointsnum = response.data.extend;
							that.pointData = response.data.data;
						} else if(response.data.code == "400") {
							self.$message({
								type: "error",
								message: "操作失败"
							});
						}
					})
					.catch(function(error) {
						//console.log(error);
					});
				}

			},
			changePoint:function(){

			},
			changeCard:function(){
				var that = this;
				that.axios.post('/myLessons/updateMyLessons', {
					mark:'xueqiu',
					id:that.changeId,
					isclock:that.cardradio
				})
				.then(function(response) {
					if(response.data.code == "600") {
						that.classList[that.currentIndex].isclock = that.cardradio;
					} else if(response.data.code == "400") {
						self.$message({
							type: "error",
							message: "操作失败"
						});
					}
				})
				.catch(function(error) {
					//console.log(error);
				});
			},
			editCard: function(isclock,id,index) {
				var that = this;
				that.editCardState = true;
				that.cardradio = isclock;
				that.changeId = id;
				that.currentIndex = index;
			},
			handleClassChange: function() {

			},
			changeCourse: function(val) {
				var that = this;
				that.currentCourseId = val;
				that.getclassData();
			},
			getData(openid) { //查询课程
				var self = this;
				self.axios.post('/myCourse/list', {
						mark: 'xueqiu',
						openid: openid
					})
					.then(function(response) {
						if(response.data.code == "600") {
							if(response.data.data.length == 0) {
								self.$message({
									type: "error",
									message: "暂无课程"
								});
							} else {
								self.courseList = response.data.data;
								self.currentCourseId = response.data.data[0].id;
								var timer = setInterval(function() {
									self.getclassData();
									clearInterval(timer);
								},100);

							}

						} else if(response.data.code == "400") {
							self.$message({
								type: "error",
								message: "操作失败"
							});
						}
					})
					.catch(function(error) {
						//console.log(error);
					});
			},
			getclassData() {
				var self = this;
				//self.loading = true;
				self.axios.post('/myLessons/getCardRecord', {
						mark: 'xueqiu',
						openid: self.currentRow.openid,
						courseid: self.currentCourseId
					})
					.then(function(response) {
						//self.loading = false;
						if(response.data.code == "600") {
							self.classList = response.data.data;
							self.dataTotal = response.data.dataTotal;
							self.$refs.singleTable.setCurrentRow(response.data.data[0]);
						} else if(response.data.code == "400") {
							self.$message({
								type: "error",
								message: "操作失败"
							});
						}
					})
					.catch(function(error) {
						//console.log(error);
					});
			},
			classRowChange: function() {

			},
			handleRowChange(val) { //选中某人
				this.currentCourseId = '';
				this.courseList = [];
				this.comPage = 1;
				this.currentRow = val;
				this.classList = [];
				this.getData(val.openid);
				this.vipopenid = val.openid;
			},
			seachstudent: function() {
				var that = this;
				this.getVipPerSons(1, this.searchname);
			},
			getVipPerSons: function(page, nickname) {
				var that = this;
				that.axios.post("/wxUser/list", {
						mark: localStorage.getItem("mark"),
						page: page,
						nickname: nickname
					})
					.then(function(response) {
						if(response.data.code == "600") {
							that.vipData = response.data.data;
							that.dataTotal = response.data.dataTotal;
						} else if(response.data.code == "400") {
							that.$message({
								type: "error",
								message: "操作失败"
							});
						} else {
							that.ifLogin();
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			handleCurrentChange: function(page) {
				this.getVipPerSons(page, this.searchname);
			},
			getpointdata:function(){
				var self = this;
				self.axios.post('/myPoints/list', {
						mark: 'xueqiu',
						openid: self.currentRow.openid,
						courseid: self.currentCourseId
					})
					.then(function(response) {
						if(response.data.code == "600") {

						} else if(response.data.code == "400") {
							self.$message({
								type: "error",
								message: "操作失败"
							});
						}
					})
					.catch(function(error) {
						//console.log(error);
					});
			}
		}
	};
</script>
<style scoped="scoped">
	.editConpon {
		background: #fff;
		padding: 15px 10px;
		margin-bottom: 20px;
		border-bottom: 2px solid #e9eef3;
	}

	.editConpon .box_item {
		width: 100%;
	}
	.editConpon .point_btn{
		float:right;
	}
	.viptable /deep/ .el-table td {
		padding: 0!important;
	}
	.load_page{
		position:fixed;
		left:0;
		top:0;
		width:100%;
		height:100%;
		z-index:999999999;
	}
	.load_page /deep/ .el-icon-loading{
		font-size:30px;
	}
	.addPoint{
		padding-bottom:10px;
		line-height:36px;
	}
	.addPoint p{
		float:left;
		margin:0;
	}
	.addPoint ._btn{
		float:right;
	}
	.clearfix:after,
	#container:after {
		content: "\0020";
		display: block;
		height: 0;
		clear: both;
		visibility: hidden;
		overflow: hidden
	}

	.pointtable /deep/ .el-dialog__body{
		padding-top:0;
	}

	.box_item ._lebel{
		float:left;
		width:10%;
		text-align:right;
		line-height:36px;
		padding-right:10px;
		box-sizing:border-box;
	}
	.box_item ._con{
		float:left;
		width:90%;
	}
</style>



// WEBPACK FOOTER //
// src/components/PlayCard.vue